import { name as PKG_NAME } from '../../../package.json'

export const DB_NAME = `${PKG_NAME}/avis`
export const DB_VERSION = 1
export const DB_STORE_NAME = 'avis'